import axios from "axios";
import state from "../store";


const getAllCities = () => axios.post(state.getters.mainAppURL + "areas/get_all_cities");
const getAllAreasUsingWildCard = (params) => axios.post(state.getters.mainAppURL + "areas/get_all_areas_using_wildcard", params);
const getAreasFromLatLng = (params) => axios.post(state.getters.mainAppURL + "areas/get_location_form_latlng", params);

export {
    getAllCities,
    getAllAreasUsingWildCard,
    getAreasFromLatLng
}